import { c as _c } from "react/compiler-runtime";
import { SiDiscord, SiFacebook, SiX } from "@icons-pack/react-simple-icons";
import { IconPhotoOff } from "@tabler/icons-react";
import Image from "next/image";
import { useState, useTransition } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@domainstack/ui/tabs";
type SocialPreviewProvider = "twitter" | "facebook" | "linkedin" | "discord" | "slack";
export function SocialPreviews(t0) {
  const $ = _c(22);
  const {
    preview,
    twitterVariant
  } = t0;
  const [selectedTab, setSelectedTab] = useState("twitter");
  const [, startTransition] = useTransition();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-[11px] tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">Open Graph</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== startTransition) {
    t2 = v => startTransition(() => setSelectedTab(v as typeof selectedTab));
    $[1] = startTransition;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TabsTrigger value="twitter" data-1p-ignore={true}><SiX className="size-4 md:size-3.5" aria-hidden={true} /><span className="hidden text-[13px] md:inline">Twitter</span></TabsTrigger>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TabsTrigger value="facebook" data-1p-ignore={true}><SiFacebook className="size-4 md:size-3.5" aria-hidden={true} /><span className="hidden text-[13px] md:inline">Facebook</span></TabsTrigger>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <TabsTrigger value="linkedin" data-1p-ignore={true}><svg viewBox="0 0 24 24" fill="currentColor" className="size-4 md:size-3.5" role="img" aria-label="Linkedin" aria-hidden={true}><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.06 2.06 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065m1.782 13.019H3.555V9h3.564zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0z" /></svg><span className="hidden text-[13px] md:inline">LinkedIn</span></TabsTrigger>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <TabsTrigger value="discord" data-1p-ignore={true}><SiDiscord className="size-4 md:size-3.5" aria-hidden={true} /><span className="hidden text-[13px] md:inline">Discord</span></TabsTrigger>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <TabsList className="h-11 w-full">{t3}{t4}{t5}{t6}<TabsTrigger value="slack" data-1p-ignore={true}><svg viewBox="0 0 24 24" fill="currentColor" className="size-4 md:size-3.5" role="img" aria-label="Slack" aria-hidden={true}><path d="M5.042 15.165a2.53 2.53 0 0 1-2.52 2.523A2.53 2.53 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52zm1.271 0a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.53 2.53 0 0 1 8.834 24a2.53 2.53 0 0 1-2.521-2.522zM8.834 5.042a2.53 2.53 0 0 1-2.521-2.52A2.53 2.53 0 0 1 8.834 0a2.53 2.53 0 0 1 2.521 2.522v2.52zm0 1.271a2.53 2.53 0 0 1 2.521 2.521 2.53 2.53 0 0 1-2.521 2.521H2.522A2.53 2.53 0 0 1 0 8.834a2.53 2.53 0 0 1 2.522-2.521zm10.122 2.521a2.53 2.53 0 0 1 2.522-2.521A2.53 2.53 0 0 1 24 8.834a2.53 2.53 0 0 1-2.522 2.521h-2.522zm-1.268 0a2.53 2.53 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.53 2.53 0 0 1 2.523 2.522zm-2.523 10.122a2.53 2.53 0 0 1 2.523 2.522A2.53 2.53 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522zm0-1.268a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.53 2.53 0 0 1-2.522 2.523z" /></svg><span className="hidden text-[13px] md:inline">Slack</span></TabsTrigger></TabsList>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = preview.imageUploaded ?? null;
  const t9 = selectedTab === "twitter" ? twitterVariant : undefined;
  let t10;
  if ($[8] !== preview.canonicalUrl || $[9] !== preview.description || $[10] !== preview.title || $[11] !== selectedTab || $[12] !== t8 || $[13] !== t9) {
    t10 = <SocialPreview provider={selectedTab} title={preview.title} description={preview.description} image={t8} url={preview.canonicalUrl} variant={t9} />;
    $[8] = preview.canonicalUrl;
    $[9] = preview.description;
    $[10] = preview.title;
    $[11] = selectedTab;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== selectedTab || $[16] !== t10) {
    t11 = <TabsContent value={selectedTab} className="mx-auto mt-4 mb-2 w-full max-w-[480px] md:max-w-[640px]">{t10}</TabsContent>;
    $[15] = selectedTab;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== selectedTab || $[19] !== t11 || $[20] !== t2) {
    t12 = <div className="mt-6 space-y-3">{t1}<Tabs value={selectedTab} onValueChange={t2}>{t7}{t11}</Tabs></div>;
    $[18] = selectedTab;
    $[19] = t11;
    $[20] = t2;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
}
function getHostname(url: string): string {
  try {
    const {
      hostname
    } = new URL(url);
    return hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}
function PreviewImage(t0) {
  const $ = _c(8);
  const {
    src,
    width,
    height,
    placeholderClassName
  } = t0;
  if (src) {
    let t1;
    if ($[0] !== height || $[1] !== src || $[2] !== width) {
      t1 = <Image src={src} alt="Preview image" width={width} height={height} className="h-full w-full object-cover select-none" draggable={false} loading="lazy" unoptimized={true} />;
      $[0] = height;
      $[1] = src;
      $[2] = width;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  const t1 = `flex h-full w-full items-center justify-center ${placeholderClassName}`;
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconPhotoOff className="h-5 w-5" aria-hidden={true} />;
    t3 = <span className="sr-only">No image</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
type PreviewCardProps = {
  hostname: string;
  title: string | null;
  description: string | null;
  image: string | null;
};
function TwitterPreview(t0) {
  const $ = _c(30);
  const {
    hostname,
    title,
    description,
    image,
    variant
  } = t0;
  if (variant === "compact") {
    let t1;
    if ($[0] !== image) {
      t1 = <div className="relative min-h-[96px] w-24 shrink-0 self-stretch bg-[#f1f5f9] dark:bg-[#0f1419]"><PreviewImage src={image} width={240} height={240} placeholderClassName="text-[#64748b] text-[11px] dark:text-[#8b98a5]" /></div>;
      $[0] = image;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== hostname) {
      t2 = <div className="truncate text-[11px] leading-4 text-[#536471] dark:text-[#8b98a5]">{hostname}</div>;
      $[2] = hostname;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const t3 = title || hostname;
    let t4;
    if ($[4] !== t3) {
      t4 = <div className="mt-0.5 line-clamp-1 text-[15px] font-semibold">{t3}</div>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== description) {
      t5 = description ? <div className="mt-0.5 line-clamp-2 text-[13px] text-[#536471] dark:text-[#8b98a5]">{description}</div> : null;
      $[6] = description;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
      t6 = <div className="min-w-0 flex-1 p-3">{t2}{t4}{t5}</div>;
      $[8] = t2;
      $[9] = t4;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t1 || $[13] !== t6) {
      t7 = <div className="mx-auto w-full max-w-[520px] overflow-hidden rounded-2xl border border-[#eff3f4] bg-white text-black dark:border-[#2f3336] dark:bg-black dark:text-white"><div className="flex">{t1}{t6}</div></div>;
      $[12] = t1;
      $[13] = t6;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  let t1;
  if ($[15] !== image) {
    t1 = <div className="relative w-full overflow-hidden bg-[#f1f5f9] dark:bg-[#0f1419]"><div className="aspect-[16/9] min-h-[160px] w-full"><PreviewImage src={image} width={1200} height={675} placeholderClassName="text-[#64748b] text-[12px] dark:text-[#8b98a5]" /></div></div>;
    $[15] = image;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  let t2;
  if ($[17] !== hostname) {
    t2 = <div className="truncate text-[11px] text-[#536471] dark:text-[#8b98a5]">{hostname}</div>;
    $[17] = hostname;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  const t3 = title || hostname;
  let t4;
  if ($[19] !== t3) {
    t4 = <div className="mt-0.5 line-clamp-2 text-[15px] font-semibold">{t3}</div>;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== description) {
    t5 = description ? <div className="mt-0.5 line-clamp-2 text-[13px] text-[#536471] dark:text-[#8b98a5]">{description}</div> : null;
    $[21] = description;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== t2 || $[24] !== t4 || $[25] !== t5) {
    t6 = <div className="p-3">{t2}{t4}{t5}</div>;
    $[23] = t2;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== t1 || $[28] !== t6) {
    t7 = <div className="overflow-hidden rounded-2xl border border-[#eff3f4] bg-white text-black dark:border-[#2f3336] dark:bg-black dark:text-white">{t1}{t6}</div>;
    $[27] = t1;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
}
function FacebookPreview(t0) {
  const $ = _c(15);
  const {
    hostname,
    title,
    description,
    image
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = <div className="relative w-full bg-[#f0f2f5] dark:bg-[#242526]"><div className="aspect-[1.91/1] min-h-[150px] w-full"><PreviewImage src={image} width={1200} height={628} placeholderClassName="text-[#606770] text-[12px] dark:text-[#b0b3b8]" /></div></div>;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hostname) {
    t2 = <div className="truncate text-[11px] font-medium tracking-wide text-[#606770] uppercase dark:text-[#b0b3b8]">{hostname}</div>;
    $[2] = hostname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = title || hostname;
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="mt-1 line-clamp-2 text-[17px] font-semibold text-[#050505] dark:text-[#e4e6eb]">{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== description) {
    t5 = description ? <div className="mt-1 line-clamp-2 text-[13px] text-[#606770] dark:text-[#b0b3b8]">{description}</div> : null;
    $[6] = description;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="bg-[#f0f2f5] px-4 py-3 dark:bg-[#3a3b3c]">{t2}{t4}{t5}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <div className="overflow-hidden rounded-md border border-[#e4e6eb] bg-white text-black dark:border-[#3a3b3c] dark:bg-[#18191a] dark:text-white">{t1}{t6}</div>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function LinkedInPreview(t0) {
  const $ = _c(12);
  const {
    hostname,
    title,
    image
  } = t0;
  let t1;
  if ($[0] !== image) {
    t1 = <div className="relative w-full bg-[#eef3f8] dark:bg-[#0b0f12]"><div className="aspect-[1200/627] min-h-[150px] w-full"><PreviewImage src={image} width={1200} height={627} placeholderClassName="text-[#6e7781] text-[12px] dark:text-[#9aa6b2]" /></div></div>;
    $[0] = image;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = title || hostname;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="line-clamp-2 text-[13px] font-semibold text-[#0a66c2] dark:text-[#70b5f9]">{t2}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hostname) {
    t4 = <div className="truncate text-[13px] text-[#6e7781] dark:text-[#9aa6b2]">{hostname}</div>;
    $[4] = hostname;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="space-y-1 px-4 py-3">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t1 || $[10] !== t5) {
    t6 = <div className="overflow-hidden border border-[#dde6f2] bg-white text-black dark:border-[#2e3a44] dark:bg-[#1d2226] dark:text-white">{t1}{t5}</div>;
    $[9] = t1;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function SlackPreview(t0) {
  const $ = _c(14);
  const {
    hostname,
    title,
    description,
    image
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute top-3 bottom-3 left-3 w-[3px] rounded bg-[#c9ced6] dark:bg-[#3a3f45]" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== hostname) {
    t2 = <div className="truncate text-[12px] leading-4 text-[#4a4e52] dark:text-[#b7bfc6]">{hostname}</div>;
    $[1] = hostname;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = title || hostname;
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="mt-1 text-[15px] font-semibold text-[#1d9bd1] dark:text-[#36c5f0]">{t3}</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== description) {
    t5 = description ? <div className="mt-1 text-[13px] text-[#4a4e52] dark:text-[#b7bfc6]">{description}</div> : null;
    $[5] = description;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== image) {
    t6 = <div className="mt-3 overflow-hidden rounded-[6px] bg-[#ecebeb] dark:bg-[#393d42]"><div className="aspect-[16/9] min-h-[150px] w-full"><PreviewImage src={image} width={1200} height={675} placeholderClassName="text-[#6b7075] text-[12px] dark:text-[#9aa6b2]" /></div></div>;
    $[7] = image;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div className="relative overflow-hidden rounded-md border border-[#e1e3e6] bg-white p-3 pl-6 text-black dark:border-[#2b2e33] dark:bg-[#1f2329] dark:text-white">{t1}{t2}{t4}{t5}{t6}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function DiscordPreview(t0) {
  const $ = _c(13);
  const {
    hostname,
    title,
    description,
    image
  } = t0;
  let t1;
  if ($[0] !== hostname) {
    t1 = <div className="truncate text-[12px] leading-4 text-[#b5bac1]">{hostname}</div>;
    $[0] = hostname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = title || hostname;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="mt-1 line-clamp-2 text-[16px] font-semibold text-[#58a6ff]">{t2}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = description ? <div className="mt-1 line-clamp-3 text-[13px] text-[#dbdee1]">{description}</div> : null;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== image) {
    t5 = <div className="mt-3 overflow-hidden rounded-md bg-[#1f2124]"><div className="aspect-[1200/628] min-h-[150px] w-full"><PreviewImage src={image} width={1200} height={628} placeholderClassName="text-[#99a1ab] text-[12px]" /></div></div>;
    $[6] = image;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <div className="rounded-lg border border-[#1f2124] bg-[#2b2d31] p-3 text-white">{t1}{t3}{t4}{t5}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function getSocialPreviewCard(provider: SocialPreviewProvider, props: PreviewCardProps, variant: "compact" | "large"): React.ReactNode {
  if (provider === "twitter") return <TwitterPreview {...props} variant={variant} />;
  if (provider === "facebook") return <FacebookPreview {...props} />;
  if (provider === "linkedin") return <LinkedInPreview {...props} />;
  if (provider === "slack") return <SlackPreview {...props} />;
  if (provider === "discord") return <DiscordPreview {...props} />;
  return null;
}
function SocialPreview(t0) {
  const $ = _c(17);
  const {
    provider,
    title,
    description,
    image,
    url,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "compact" : t1;
  let hostname;
  let t2;
  if ($[0] !== description || $[1] !== image || $[2] !== provider || $[3] !== title || $[4] !== url || $[5] !== variant) {
    hostname = getHostname(url);
    t2 = getSocialPreviewCard(provider, {
      hostname,
      title,
      description,
      image
    }, variant);
    $[0] = description;
    $[1] = image;
    $[2] = provider;
    $[3] = title;
    $[4] = url;
    $[5] = variant;
    $[6] = hostname;
    $[7] = t2;
  } else {
    hostname = $[6];
    t2 = $[7];
  }
  const card = t2;
  if (!card) {
    let t3;
    if ($[8] !== provider || $[9] !== variant) {
      t3 = <div className="flex h-48 w-full items-center justify-center rounded-md border text-[12px] text-[#64748b] dark:text-[#8b98a5]" data-slot="social-preview" data-provider={provider} data-variant={variant}>No preview available.</div>;
      $[8] = provider;
      $[9] = variant;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  const t3 = `Open ${hostname} in a new tab`;
  let t4;
  if ($[11] !== card || $[12] !== provider || $[13] !== t3 || $[14] !== url || $[15] !== variant) {
    t4 = <a href={url} target="_blank" rel="noopener" aria-label={t3} data-slot="social-preview" data-provider={provider} data-variant={variant} className="w-full font-[system-ui]">{card}</a>;
    $[11] = card;
    $[12] = provider;
    $[13] = t3;
    $[14] = url;
    $[15] = variant;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}